export const PAY_FREQUENCIES = [
  { value: 'W', label: 'Weekly' },
  { value: 'B', label: 'Every two weeks' },
  { value: 'S', label: 'Twice per month' },
  { value: 'M', label: 'Monthly' },
];
